<template>
  <layout>
    <h4>
      Pages templates
      <router-link
        :to="{ name: 'pages-generator.create' }"
        class="btn btn-sm btn-primary">Create
      </router-link>
    </h4>
    <pages-base-table
      ref="tableList"
      :resource="resource">

      <template
        slot="status"
        slot-scope="{ item }">
        <span 
          v-if="item.status === 'error'" 
          style="color: red">{{ item.status }}</span>
        <svg 
          v-else-if="item.status === 'processing'" 
          xmlns:svg="http://www.w3.org/2000/svg"
          xmlns="http://www.w3.org/2000/svg" 
          xmlns:xlink="http://www.w3.org/1999/xlink" 
          version="1.0" 
          width="32px"
          height="32px" 
          viewBox="0 0 128 128" 
          xml:space="preserve"><rect 
            x="0" 
            y="0" 
            width="100%" 
            height="100%" 
            fill="#FFFFFF" />
          <g><circle 
            cx="16" 
            cy="64" 
            r="16" 
            fill="#000000" 
            fill-opacity="1"/>
            <circle 
              cx="16" 
              cy="64" 
              r="14.344" 
              fill="#000000" 
              fill-opacity="1" 
              transform="rotate(45 64 64)"/>
            <circle 
              cx="16" 
              cy="64" 
              r="12.531" 
              fill="#000000" 
              fill-opacity="1" 
              transform="rotate(90 64 64)"/>
            <circle 
              cx="16" 
              cy="64" 
              r="10.75" 
              fill="#000000" 
              fill-opacity="1" 
              transform="rotate(135 64 64)"/>
            <circle 
              cx="16" 
              cy="64" 
              r="10.063" 
              fill="#000000" 
              fill-opacity="1" 
              transform="rotate(180 64 64)"/>
            <circle 
              cx="16" 
              cy="64" 
              r="8.063" 
              fill="#000000" 
              fill-opacity="1" 
              transform="rotate(225 64 64)"/>
            <circle 
              cx="16" 
              cy="64" 
              r="6.438" 
              fill="#000000" 
              fill-opacity="1" 
              transform="rotate(270 64 64)"/>
            <circle 
              cx="16" 
              cy="64" 
              r="5.375" 
              fill="#000000" 
              fill-opacity="1" 
              transform="rotate(315 64 64)"/>
            <animateTransform 
              attributeName="transform" 
              type="rotate"
              values="0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64"
              calcMode="discrete" 
              dur="720ms" 
              repeatCount="indefinite"/></g></svg>
        <span v-else>{{ item.status }}</span>
      </template>

    </pages-base-table>
  </layout>
</template>

<script>
import Layout from '../layouts/Default.vue';
import Proxy from './Proxy';
import PagesBaseTable from '../components/PagesBaseTable.vue';

const resourceBase = 'pages-generator';

export default {
  name: 'PagesIndex',

  components: {
    Layout,
    PagesBaseTable,
  },

  data() {
    return {
      timeInterval: null,
      resource: {
        base: resourceBase,
        proxy() {
          return new Proxy();
        },
        sortBy: 'created_at',
        sortDesc: true,
        perPage: 9,
        fields: [
          {
            key: 'id',
            label: 'ID',
            sortable: true,
          },
          {
            key: 'locale',
            label: 'Locale',
            sortable: true
          },
          {
            key: 'title',
            label: 'Title',
            sortable: true,
          },
          {
            key: 'status',
            label: 'Status',
            sortable: true,
          },
          {
            key: 'created_at',
            label: 'Created',
            sortable: true,
          },
        ],
      },
    };
  },

  created() {

    this.timeInterval = setInterval(() => {
      this.$refs.tableList.refresh();
    }, 10000);

  },

  destroyed() {
    clearInterval(this.timeInterval);
  }

};
</script>
